var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: _vm.bemBlock },
    _vm._l(_vm.breadcrumbs, function(item) {
      return _c("li", { key: item.name, class: _vm.bemElement("list-item") }, [
        item !== _vm.lastBreadcrumb
          ? _c(
              "a",
              {
                class: [
                  _vm.bemElement("link", {
                    disabled: item.byl_renderType
                  }),
                  "link",
                  "interaction--enabled-hover-v1"
                ],
                attrs: { href: item.url }
              },
              [_vm._v(_vm._s(item.name))]
            )
          : _vm.breadcrumbNotAsH1
          ? _c("span", [_vm._v(_vm._s(item.name))])
          : _c("h1", [_vm._v("\n      " + _vm._s(item.name) + "\n    ")])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }